import React from 'react';
import styled from 'styled-components';
import {
    buttonLikeStyles,
    buttonLikeTextStyles,
    ButtonVariant,
} from 'components/button/buttonStyles';

interface StyleProps {
    variant?: ButtonVariant;
    disabled?: boolean;
}

const SLinkButton = styled.a<StyleProps>`
    ${buttonLikeStyles}
`;

const SParagraph = styled.p<StyleProps>`
    ${buttonLikeTextStyles}
`;

const SPrependIcon = styled.span`
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
`;

interface Props
    extends StyleProps,
        Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'title' | 'href'> {
    href: string;
    title: string;
    className?: string;
    prependIcon?: React.ReactNode;
}

export const Link = ({
    href,
    title = 'Title',
    variant = 'filled',
    disabled = false,
    className,
    prependIcon,
    ...anchorProps
}: Props) => {
    return (
        <SLinkButton
            href={href}
            variant={variant}
            disabled={disabled}
            className={className}
            {...anchorProps}>
            {prependIcon ? <SPrependIcon>{prependIcon}</SPrependIcon> : null}
            <SParagraph variant={variant}>{title}</SParagraph>
        </SLinkButton>
    );
};
